import { getApiKey } from './config.js';
import { error } from './output.js';

/**
 * Guard: checks that AGT_API_KEY is set.
 * Returns false (and prints an error) if not.
 */
export function requireAuth(): boolean {
  const key = getApiKey();
  if (!key) {
    error('AGT_API_KEY is not set. Export it with your host API key (tlk_...)');
    process.exitCode = 1;
    return false;
  }
  return true;
}

/**
 * Guard: checks that AGT_API_KEY is set.
 * Team auto-resolves from the API key exchange.
 * Returns a truthy string on success, or null on failure.
 */
export function requireTeam(): string | null {
  if (!requireAuth()) return null;
  return 'auto'; // team resolves from exchange
}
